import React, {Component} from "react";
import {ReactifyChartColors} from "../../util/ReactifyChartColors";

import Chart from "react-apexcharts";

const colors = ReactifyChartColors();

class LineChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                // colors: [
                //     colors.ReactifyChartColor1,
                //     colors.ReactifyChartColor2,
                //     colors.ReactifyChartColor3,
                //     colors.ReactifyChartColor4,
                //     colors.ReactifyChartColor5,
                // ],
                chart: {
                    id: props.id,

                    toolbar: {
                        export: {
                            svg: {
                                filename: props.title
                            },
                            png: {
                                filename: props.title
                            }
                        }
                    }
                },
                xaxis: {
                    categories: ["Sun", "Mon", "Tue", "Thur", "Fri", "Sat"]
                },
                title: {
                    text: props.title
                },

                legend: {
                    show: true,
                    formatter: (seriesName, opts) => {
                        return [
                            seriesName,
                            " - ",
                            opts.w.globals.series[opts.seriesIndex].reduce((acc, v) => {acc += v; return acc;}, 0).toLocaleString()
                        ]
                    }
                },
            },
            responsive: [
                {
                    breakpoint: 1000,
                    options: {
                        plotOptions: {
                            bar: {
                                horizontal: false
                            }
                        }
                    }
                }
            ],
            series: []
        };
    }

    render() {
        const seriesData = this.props.series ? this.props.series : this.state.series
        const allSeriesXPoints = seriesData.map(series => series.data.map(point => point.x))
            .reduce((acc, val) => acc.concat(val), [])  // flatten
            .sort()
        const filledSeriesData = seriesData.map(series => {
            const seriesXMap = series.data.reduce((acc, point) => {
                acc[point.x] = point.y
                return acc
            }, {})

            return {
                ...series,
                data: [
                    ...allSeriesXPoints.map(x => {
                        return {x: x, y: seriesXMap.hasOwnProperty(x) ? seriesXMap[x] : 0}
                    })
                ]
            }
        })
        return (
            <Chart
                options={{
                    ...this.state.options,
                    noData: {
                        text: this.props.hasError ? 'Error loading!' : (this.props.isLoading ? 'Loading ...' : 'No Data')
                    },
                }}
                series={filledSeriesData}
                type="line"
                width="100%"
                height="100%"
            />
        );
    }
}

export default LineChart;
